import { getOfflinePayloadData } from "./preparePayload";

const getMandatoryEnv = require("../utils/getMandatoryEnv");

const { donationServiceConfig } = getMandatoryEnv(["donationServiceConfig"]);
const customError = "Something went wrong, Please try again later!";

function donationsOfflineService(
  formData,
  setLoader,
  onFailure,
  offlineDonationState = { showOfflineSection: false }
) {
  const { offlineDonationUri } = donationServiceConfig;
  const payload = getOfflinePayloadData(offlineDonationState, formData);
  setLoader(true);

  fetch(offlineDonationUri, {
    method: "POST",
    headers: new Headers({ "Content-type": "application/json" }),
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.ok) {
        response.json().then((json) => {
          setLoader(false);
          if (json.error) {
            const furl = new URL(formData.paymentFailureUrl);
            furl.searchParams.set("type", "offline");
            furl.searchParams.set("status", "failure");
            window.location.href = furl.href;
          } else {
            const surl = new URL(formData.paymentSuccessUrl);
            surl.searchParams.set("type", "offline");
            surl.searchParams.set("status", "success");
            window.location.href = surl.href;
          }
        });
      } else {
        setLoader(false);
        /* return */
        if ("statusText" in response && !!response.statusText) {
          onFailure(`customErrorMessage: ${customError}`);
        }
      }
    })
    .catch(() => {
      setLoader(false);
      onFailure(`customErrorMessage: ${customError}`);
    });
}

export default donationsOfflineService;
